import { useCallback, useState } from "react";

import { Button } from "primereact/button";

import { C, themeClasses as T } from "sj-ui-toolkit/src/atlas/utils";

import { useTournamentContext } from "../../../context/TournamentContext";

export default function TournamentStart() {
  const { tournamentLessonNotStarted, beginTournamentLesson } = useTournamentContext();
  const [showDialog, setShowDialog] = useState(tournamentLessonNotStarted);

  const handleBegin = useCallback(() => {
    beginTournamentLesson();
    setShowDialog(false);
  }, [beginTournamentLesson]);

  if (!showDialog) {
    return null;
  }

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/30 z-50 rounded-l-sm -m-3">
      <div className={C("rounded-lg shadow-lg p-8 max-w-md", T.bgElevation2)}>
        <div className="text-center w-sm">
          <div className="flex justify-center mb-6">
            <i className={C("pi pi-check-circle text-5xl", T.textSuccess)} />
          </div>
          <h2 className={C("text-3xl font-bold mb-3")}>Lesson Ready</h2>
          <p className={C("mb-6", T.textSecondary)}>
            When you are ready to start, click Begin below.
          </p>
          <Button
            label="Begin"
            icon="pi pi-arrow-right"
            onClick={handleBegin}
            data-testid="tournament-lesson-begin-button"
          />
        </div>
      </div>
    </div>
  );
}
